enum ValidationStatusOverrideType {
  Automatic = 0,
  Valid = 1,
  Invalid = 2,
  NotValidatable = 3
}

export default ValidationStatusOverrideType;
